import {
  css,
  DefaultTheme,
  FlattenSimpleInterpolation,
} from 'styled-components/macro';
import { IInputSize, IInputState } from './types';
import { DSColorValues } from 'styles';

export const FormWidths: { [key in IInputSize]: FlattenSimpleInterpolation } = {
  l: css`
    width: 750px;
  `,
  m: css`
    width: 550px;
  `,
  s: css`
    width: 350px;
  `,
  inherit: css`
    width: inherit;
  `,
};

export const FormStateColors = (
  theme: DefaultTheme
): Record<
  IInputState,
  {
    border: DSColorValues;
    borderFocus: DSColorValues;
    text: DSColorValues;
  }
> => ({
  default: {
    border: theme.colors.gray['300'],
    borderFocus: theme.colors.primary['500'],
    text: theme.colors.gray['500'],
  },
  success: {
    border: theme.colors.green['300'],
    borderFocus: theme.colors.green['600'],
    text: theme.colors.green['500'],
  },
  warning: {
    border: theme.colors.orange['300'],
    borderFocus: theme.colors.orange['600'],
    text: theme.colors.orange['500'],
  },
  error: {
    border: theme.colors.red['500'],
    borderFocus: theme.colors.red['600'],
    text: theme.colors.red['500'],
  },
  pending: {
    border: theme.colors.gray['300'],
    borderFocus: theme.colors.primary['500'],
    text: theme.colors.gray['500'],
  },
});
